import React from "react";

interface ImagePreviewProps {
  fileUrl: string;
  fileName: string;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({
  fileUrl,
  fileName,
}) => {
  return (
    <div className="flex h-full min-h-[400px] items-center justify-center overflow-auto bg-gray-50 dark:bg-gray-950 p-4">
      <img
        src={fileUrl}
        alt={fileName}
        className="max-h-full max-w-full object-contain"
      />
    </div>
  );
};
